let config = {
  'title': 'DNF七夕活动，QQ浏览器送大礼',
  'keywords': 'DNF 七夕 活动',
  'description': 'DNF七夕QQ浏览器送大礼'
};

config.layout = require('@layout/single');

require('./index.css');

config.qbtop = [
  require('@tencent/pcqb-act-header')
];

config.qbheader = [];

config.qbbody = [
  require('@modules/game_header'),
  require('@modules/game_body')
];

config.qbfooter = [
  require('@tencent/pcqb-act-footer')
];

module.exports = config;



// WEBPACK FOOTER //
// ./pages/index/config.js